import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LeaderRoutingModule } from './leader-routing.module';
import {
  WardInformationComponent,
  StakeWardsSelectComponent,
  WardLeaderFormComponent,
  StakeInformationComponent,
  StakeLeaderFormComponent,
  WardGroupsComponent,
  WardGroupAssignmentsLookupComponent,
  LocalStudentManagementComponent,
  WardGroupAssignmentsComponent,
  WardDirectoryComponent,
  WardDirectoryListComponent,
  EmailComponent,
  ComposeEmailDialogComponent
} from '../leader';
import { AdminModule } from '../admin/admin.module';

@NgModule({
  imports: [CommonModule, LeaderRoutingModule, SharedModule, AdminModule],
  declarations: [
    WardInformationComponent,
    StakeWardsSelectComponent,
    WardLeaderFormComponent,
    StakeInformationComponent,
    StakeLeaderFormComponent,
    WardGroupsComponent,
    WardGroupAssignmentsLookupComponent,
    WardGroupAssignmentsComponent,
    LocalStudentManagementComponent,
    WardDirectoryComponent,
    WardDirectoryListComponent,
    WardDirectoryListComponent,
    ComposeEmailDialogComponent,
    EmailComponent
  ],
  entryComponents: [ComposeEmailDialogComponent]
})
export class LeaderModule {}
